import { combineReducers } from 'redux'
import { reducers } from 'label-insight-app-shell'
import locationReducer from './location'

export const makeRootReducer = (asyncReducers) => (
  combineReducers({
    location: locationReducer,
    ...reducers,
    ...asyncReducers
  })
)

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js